import { isFeatureEnabled } from "./appConfigurations";

// Gates the "Group" switch on the sites map (CS AB#49944). Off = no switch and
// sites always grouped, the map as it was before.
export const MAP_GROUP_FEATURE_FLAG = "CS_49944_MAP_GROUP";

export const selectMapGroupEnabled = isFeatureEnabled(MAP_GROUP_FEATURE_FLAG);
